import Root from './checkbox.svelte';
export {
  //
  Root as Checkbox,
  Root
};
